import { PublicClientApplication } from '@azure/msal-browser';

// Entra ID SSO config. Set these in .env (see .env.example) — they're not secrets (a SPA is a
// public client; the tenant/client IDs are visible in any auth request), unlike the Power
// Automate flow URLs.
const TENANT_ID = process.env.REACT_APP_ENTRA_TENANT_ID;
const CLIENT_ID = process.env.REACT_APP_ENTRA_CLIENT_ID;

// The custom scope exposed by the API's app registration ("Expose an API" → access_as_user).
// Requesting this — rather than a Graph scope — is what makes Entra issue an access token whose
// audience is our own API, which is exactly what apps/api validates against.
export const API_SCOPE = `api://${CLIENT_ID}/access_as_user`;
export const loginRequest = { scopes: [API_SCOPE] };

// Popups land on public/blank.html, NOT on the app (2026-08-12). With the default redirectUri the
// popup loads a second copy of the SPA, which fires its own token requests and tries to open a
// popup from inside a popup: MSAL blocks it (block_nested_popups) and the abandoned interaction
// leaves interaction_in_progress stuck until session storage is cleared.
// Requires `<origin>/blank.html` to be registered as a SPA redirect URI in Entra.
export const popupRequest = { ...loginRequest, redirectUri: `${window.location.origin}/blank.html` };

// True only when both IDs are configured. Lets the app degrade to an explanatory screen instead
// of MSAL throwing an opaque error at startup when someone hasn't filled in .env yet.
export const isAuthConfigured = Boolean(TENANT_ID && CLIENT_ID);

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID ?? 'not-configured',
    authority: `https://login.microsoftonline.com/${TENANT_ID ?? 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage over localStorage: tokens die with the browser tab rather than lingering on
    // a shared/kiosk machine. Users re-auth silently via the Entra session cookie anyway.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
});
